import { Injectable } from "@angular/core";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { Observable, of as observableOf } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { Helper, parseApiResponseArray2, parseApiResponseObject2 } from "@helpers/functions";
import { PaymentsCryptocoin } from "@modules/+new/payments/shared-payments/entities/payments-cryptocoin.model";
import { DepositWalletAddress } from "@modules/+new/payments/features/crypto-deposit/domain/entities/deposit-wallet-address.model";
import { AssetSettings } from "@models/tradable/split/asset_settings";
import { HttpHeaders } from "@angular/common/http";

@Injectable({
	providedIn: "root"
})
export class CryptoDepositRemote {
	constructor(private readonly apicallService: ApicallService) {}

	public getDepositCryptocoins(): Observable<PaymentsCryptocoin[]> {
		const opt = new ApicallOption();
		opt.headers = new HttpHeaders().set("Accept", "application/json");
		return this.apicallService.get("payments/cryptocoin", opt).pipe(
			map((response: PaymentsCryptocoin[]) => parseApiResponseArray2<PaymentsCryptocoin>(response)),
			catchError((err) => {
				Helper.handleError(err);
				return [];
			})
		);
	}

	public getAddressByCoinNetworkId(coin_network_id: string, walletId: string): Observable<DepositWalletAddress> {
		const options = new ApicallOption(null, {
			coin_network_id: coin_network_id,
			wallet_pid: walletId
		});
		return this.apicallService
			.post("payments/wallet/address", options)
			.pipe(map((response: DepositWalletAddress) => parseApiResponseObject2<DepositWalletAddress>(response)));
	}

	public getAssetSettings(): Observable<AssetSettings[]> {
		return this.apicallService.get("assets/settings", new ApicallOption(AssetSettings)).pipe(
			map((list: AssetSettings[]) => list),
			catchError((error) => {
				Helper.handleError(error);
				return observableOf([]);
			})
		);
	}
}
